import { MaxWidthContainer } from 'components/city-blocks/max-width-container';
import React from 'react';

interface IProps {
  className?: string;
  columnsClassName?: string;
  children: React.ReactNode;
  title: React.ReactNode | string;
}

export const AllLinksSection: React.FC<IProps> = ({ className, columnsClassName, title, children }) => (
  <MaxWidthContainer className={className}>
    <div className='text-center md:text-left'>
      <h3 className='mb-4 text-lg font-bold text-neutral-800 underline'>{title}</h3>
      <div
        className={`cursor-pointer text-lg font-normal leading-normal text-neutral-500 underline underline-offset-2 md:columns-3 md:gap-8 [&>*:hover]:text-neutral-700 ${columnsClassName}`}>
        {children}
      </div>
    </div>
  </MaxWidthContainer>
);
